export function canVehicleTransport(e, type) {
  const vehicle_id = $(e).val();
  const rc_id = $('#st-number').text();
  if (vehicle_id === '') {
    $(`#trip-${type}-warnings`).addClass('d-none');
    $(`#trip-${type}-error`).addClass('d-none');
    return;
  }
  $.get(`/vehicles/${vehicle_id}/validate_trip_requirements?st=${rc_id}`)
    .done((res) => {
      $(`#trip-${type}-error`).addClass('d-none');
      if (res.message !== '') {
        $(`#trip-${type}-warnings`).removeClass('d-none');
        $(`#trip-${type}-warnings-message`).text(res.message);
      }
    })
    .fail((res) => {
      $(`#trip-${type}-warnings`).addClass('d-none');
      $(`#trip-${type}-error`).removeClass('d-none');
      $(`#trip-${type}-error-message`).text(res.responseJSON.message);
    });
}

export function canDriverTransport(e) {
  const driver_id = $(e).val();
  const rc_id = $('#st-number').text();
  if (driver_id === '') {
    $('#trip-driver-warnings').addClass('d-none');
    $('#trip-driver-error').addClass('d-none');
    return;
  }
  $.get(`/drivers/${driver_id}/validate_trip_requirements?st=${rc_id}`)
    .done((res) => {
      $('#trip-driver-error').addClass('d-none');
      if (res.message !== '') {
        $('#trip-driver-warnings').removeClass('d-none');
        $('#trip-driver-warnings-message').text(res.message);
      }
    })
    .fail((res) => {
      $('#trip-driver-warnings').addClass('d-none');
      $('#trip-driver-error').removeClass('d-none');
      $('#trip-driver-error-message').text(res.responseJSON.message);
    });
}
